import React, { useEffect } from "react";
import {
  FaGlobe,
  FaLaptopCode,
  FaShieldAlt,
  FaThumbsUp,
  FaUniversalAccess,
  FaLightbulb,
  FaChartLine,
  FaAward,
} from "react-icons/fa";

const DEFAULT_ITEMS = [
  { icon: <FaGlobe />, title: "100% Digital" },
  { icon: <FaLaptopCode />, title: "Tecnológico" },
  { icon: <FaShieldAlt />, title: "Seguro" },
  { icon: <FaThumbsUp />, title: "Sem burocracia" },
  { icon: <FaUniversalAccess />, title: "Acessível" },
  { icon: <FaLightbulb />, title: "Inovador" },
  { icon: <FaChartLine />, title: "Transparente" },
  { icon: <FaAward />, title: "Humano" },
];

export const WhyChooseUs = ({ items, title }) => {
  const list =
    items && items.length > 0
      ? items.map((it) => ({ icon: it.icon, title: it.label || it.title }))
      : DEFAULT_ITEMS;

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: 0 }
    );

    const elements = document.querySelectorAll(".why-choose-us .reveal");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="why-choose-us">
      <div className="why-container">
        <span className="why-eyebrow reveal">
          <span className="why-eyebrow-dot" aria-hidden="true"></span>
          Por que CORE bank
        </span>
        <h2 className="why-title reveal">
          {title || "Tudo que um banco digital precisa ser"}
        </h2>
        <p className="why-subtitle reveal">
          Tecnologia, segurança e atendimento humano em cada detalhe da sua
          experiência financeira.
        </p>

        <div className="why-cards-container">
          {list.map((item, index) => (
            <article
              key={index}
              className="why-card reveal"
              style={{ "--i": index }}
            >
              <div className="why-icon-chip" aria-hidden="true">
                <span className="why-icon">{item.icon}</span>
              </div>
              <p className="why-card-title">{item.title}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
